import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/api/services";

export const useSaml = () => {
  return useMutation({
    mutationFn: (email: string) => authApi.saml({ email }),
  });
};
